const CHAT_API_BASE_URL =
  'https://hal-cos-prd-gwc-fnapp-v1.azurewebsites.net/api'

export const CHAT_ENDPOINTS = {
  validation: (endpoint) => `${CHAT_API_BASE_URL}/${endpoint}`,

  segmentation:
    'https://halisi-hair-segmentation.azurewebsites.net/api/createsegmentationmask',

  extractVisualOutput: `${CHAT_API_BASE_URL}/extractvisualoutput`,

  createProductRecommendation: `${CHAT_API_BASE_URL}/createproductrecommendation`,

  createRoutineAdvice: `${CHAT_API_BASE_URL}/createroutineadvice`,

  submitRecord: `${CHAT_API_BASE_URL}/submitrecord`,
  ExtractUserData: `${CHAT_API_BASE_URL}/ExtractUserData`,
}
